import { Component, OnInit } from '@angular/core';
import { ApiService } from './../../api/api.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  notificationTitle:string = '';
  notificationUrl:string = '';
  notificationDescription:string = '';
  notificationBtnName:string = '';
  cls_marquee:any = '';
  constructor(private api: ApiService) { }

  ngOnInit(): void {

    this.api.showJcmarquee().subscribe((result: any) => {
      this.cls_marquee = result;
      //console.log(this.cls_marquee)
      // console.log(result[0]['startdate']);
      // console.log(result[0]['enddate']);
      // this.notificationTitle = result[0]['title'];
      // this.notificationDescription = result[0]['description'];
      // this.notificationUrl = result[0]['url'];
      // this.notificationBtnName = result[0]['button_name'];
    });

  }

}
